import { Clickable, P } from '@ahmdigital/ui';

import constants from '../../../../ahm-constants';
import styles from '../../styles.module.sass';

type DocIconSubsectionProps = {
  description?: string;
  hasLoginLink?: boolean;
  icon?: string;
  title: string;
  to: string;
};

const loginLink = (
  <Clickable
    analytics={{ label: 'Log in Downloads Page' }}
    icon={{ name: 'chevron-right', position: 'right' }}
    to={constants.URLS.MEMBERS.HOME}
  >
    Log in
  </Clickable>
);

const DocIconSubsection = ({
  // @ts-expect-error - Automatic, Please fix when editing this file
  description = null,
  hasLoginLink = false,
  icon = 'document',
  title,
  to,
}: DocIconSubsectionProps) => (
  <div className={styles.infoBlock}>
    {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'string' is not assignable to type '"time" | "list" | "search" | "phone-circle" | "document" | "ambulance-services" | "ambulance" | "app-chevron-down" | "app-chevron-left" | "app-chevron-right" | "app-chevron-up" | ... 93 more ... | "youtube"'. */}
    <Clickable icon={{ name: icon }} inNewTab to={to}>
      {title}
    </Clickable>
    {description && <P>{description}</P>}
    {hasLoginLink && <P>But just a heads up: You can do this in your account. {loginLink}</P>}
  </div>
);

export default DocIconSubsection;
